export default __webpack_public_path__ + "static/media/3_Intro.64139d9c.mp4";